module.exports = __webpack_public_path__ + "img/win_line.b9b57b41.png";